<template>
    <div>
        <div class="grid-x grid-padding-x tabs-menu" v-if="tabs.length">
            <a ref="tabs" v-for="(tab, i) in tabs" :key="i" title="tab.label" @click="selectTab(i)" :class="['cell', 'auto', 'text-center', { active: i === currentTabIndex }]">{{ tab.label }}</a>
            <hr ref="underline" class="underline"/>
        </div>
        <div class="tabs-container">
            <div v-for="(tab, i) in tabs" :key="i">
                <slot :name="tab.key" v-if="i === currentTabIndex"></slot>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
@Component
export default class SlidingTabMenu extends Vue {

    @Prop(Array) readonly tabs!: [{key: string, label: string}];
    currentTabIndex: number  = 0;

    mounted() {
        this.updateUnderlinePosition();
    }

    @Watch('currentTabIndex')
    updateUnderlinePosition() {
        const underline = this.$refs['underline'] as HTMLElement;
        const tabs = this.$refs['tabs'] as HTMLElement[];
        underline.style.left = tabs[this.currentTabIndex].offsetLeft + 'px';
        underline.style.width = tabs[this.currentTabIndex].getBoundingClientRect().width + 'px';
    }

    get isSelected() {
        return (index: number) => this.currentTabIndex === index;
    }

    selectTab(index: number) {
        return this.currentTabIndex = index;
    }

}
</script>
<style lang="scss">
.tabs-menu {
    position: relative;

    a {
        max-width: 100%;
        color: var(--battleship-gray);
        border-bottom: 1px solid var(--light-gray);
        padding-bottom: 5px;

        &.active {
            color: var(--primary);
            font-weight: 600;

            &:after {
                display: block;
                content: attr(title);
                font-weight: 900;
                height: 1px;
                color: transparent;
                overflow: hidden;
                visibility: hidden;
            }
        }

    }
    .underline {
        position: absolute;
        bottom: 0;
        margin: 0;
        height: 3px;
        background: var(--primary);
        transition: all .3s ease;
        border-radius: var(--underline-radio-radius);
        border: 0;
    }
}
.tabs-container {
    padding: 20px 0;
}
</style>